import React from 'react';
import {Button, Empty, Form, Input, List, Typography} from 'antd';
import {useTranslation} from '../../../../hooks/useTranslation';
import {useQuery} from '@tanstack/react-query';
import {apiRequest} from '../../../../utils/AxiosHelper';
import API from '../../../settings/APIs';

const {Text} = Typography;
const {TextArea} = Input;

interface EventActivityProps {
  eventId?: string;
  activePanel: string;
}

const EventActivity: React.FC<EventActivityProps> = ({eventId}) => {
  const {t} = useTranslation();
  const [form] = Form.useForm();

  const {data: tracking, isLoading} = useQuery({
    queryKey: ['events', 'tracking', eventId],
    queryFn: async () => {
      const response = await apiRequest.get(API.events.tracking.list(eventId!));
      return response.data?.data || response.data || [];
    },
    enabled: !!eventId,
    staleTime: 2 * 60 * 1000,
  });

  const notes: any[] = Array.isArray(tracking) ? tracking : [];

  return (
    <div style={{padding: 24, display: 'flex', flexDirection: 'column', gap: 24}}>
      <Form form={form} layout="vertical">
        <Form.Item name="note" label={t('events.activity.addNote')}>
          <TextArea rows={3} placeholder={t('events.activity.notePlaceholder')}/>
        </Form.Item>
        <Button type="primary" size="small">
          {t('events.activity.saveNote')}
        </Button>
      </Form>

      {notes.length === 0 && !isLoading ? (
        <Empty description={t('events.activity.empty')}/>
      ) : (
        <List
          loading={isLoading}
          dataSource={notes}
          renderItem={(item: any) => (
            <List.Item>
              <List.Item.Meta
                title={<Text strong>{item.author || item.createdBy}</Text>}
                description={item.note || item.description}
              />
              <Text type="secondary" style={{fontSize: 12}}>{item.createdAt}</Text>
            </List.Item>
          )}
        />
      )}
    </div>
  );
};

export default EventActivity;
